import { useDispatch, useSelector } from "../../../redux/hooks";
import { Modal, Text } from "@mantine/core";
import { setDeisolatedTimeModalOpen } from "../../../redux/slices/generatorFeaturesSlice";
import { Flex } from "../../../styled";
import { Button } from "../../../components/shared/Button/Button";
import { useIsNewEntry, usePostApi } from "../../../hooks";
import { getYachtId } from "../../../utils";
import { useParams } from "react-router-dom";
import { useTriggerAutoSave } from "../../hooks/useTriggerAutoSave";
import { setEditing } from "../../../redux/slices/entrySlice";
import { setDeisolate } from "../../../redux/slices/generatorSlice";

const DeisolatedTimeModal = () => {
  const dispatch = useDispatch();
  const { lbeidOrPartId, lbid } = useParams();
  const { deisolatedTimeModalData } = useSelector(
    s => s.generatorFeaturesSlice,
  );
  const triggerAutoSave = useTriggerAutoSave();
  const isNewEntry = useIsNewEntry(false);
  const { post } = usePostApi();
  const handleAcknowledge = async () => {
    if (!deisolatedTimeModalData) return;

    await post({
      request: "record-history-action",
      body: {
        params: {
          yachtid: getYachtId(),
          lbid,
          lbeid: lbeidOrPartId,
          action: `User acknowledged ${deisolatedTimeModalData.timeKey} hours Deisolate popup`,
        },
      },
    });

    dispatch(setDeisolate({ key: deisolatedTimeModalData.timeKey }));
    dispatch(setDeisolatedTimeModalOpen(null));
    setTimeout(() => {
      triggerAutoSave();
    }, 500);
  };

  if (isNewEntry) return null;
  const isOpen = Boolean(deisolatedTimeModalData);

  return (
    <Modal opened={isOpen} onClose={handleAcknowledge} title="Warning">
      <Text>Check for anything that is still isolated.</Text>
      <Flex justify="flex-end">
        <Button onClick={handleAcknowledge}>Okay</Button>
      </Flex>
    </Modal>
  );
};
export default DeisolatedTimeModal;
